module.exports = __webpack_public_path__ + "static/img/RAL_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAL_1.png
// module id = p8F3
// module chunks = 0